/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiNurseryManagerReportsGetInvOutDetailsReportPost } from '../fn/reports/api-nursery-manager-reports-get-inv-out-details-report-post';
import { ApiNurseryManagerReportsGetInvOutDetailsReportPost$Params } from '../fn/reports/api-nursery-manager-reports-get-inv-out-details-report-post';
import { apiNurseryManagerReportsGetInvOutDetailsReportPost$Plain } from '../fn/reports/api-nursery-manager-reports-get-inv-out-details-report-post-plain';
import { ApiNurseryManagerReportsGetInvOutDetailsReportPost$Plain$Params } from '../fn/reports/api-nursery-manager-reports-get-inv-out-details-report-post-plain';
import { apiNurseryManagerReportsGetInvOutReportPost } from '../fn/reports/api-nursery-manager-reports-get-inv-out-report-post';
import { ApiNurseryManagerReportsGetInvOutReportPost$Params } from '../fn/reports/api-nursery-manager-reports-get-inv-out-report-post';
import { apiNurseryManagerReportsGetInvOutReportPost$Plain } from '../fn/reports/api-nursery-manager-reports-get-inv-out-report-post-plain';
import { ApiNurseryManagerReportsGetInvOutReportPost$Plain$Params } from '../fn/reports/api-nursery-manager-reports-get-inv-out-report-post-plain';
import { apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost } from '../fn/reports/api-nursery-manager-reports-get-inv-out-summary-details-report-post';
import { ApiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Params } from '../fn/reports/api-nursery-manager-reports-get-inv-out-summary-details-report-post';
import { apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain } from '../fn/reports/api-nursery-manager-reports-get-inv-out-summary-details-report-post-plain';
import { ApiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain$Params } from '../fn/reports/api-nursery-manager-reports-get-inv-out-summary-details-report-post-plain';
import { apiNurseryManagerReportsGetInvOutSummaryReportPost } from '../fn/reports/api-nursery-manager-reports-get-inv-out-summary-report-post';
import { ApiNurseryManagerReportsGetInvOutSummaryReportPost$Params } from '../fn/reports/api-nursery-manager-reports-get-inv-out-summary-report-post';
import { apiNurseryManagerReportsGetInvOutSummaryReportPost$Plain } from '../fn/reports/api-nursery-manager-reports-get-inv-out-summary-report-post-plain';
import { ApiNurseryManagerReportsGetInvOutSummaryReportPost$Plain$Params } from '../fn/reports/api-nursery-manager-reports-get-inv-out-summary-report-post-plain';
import { apiNurseryManagerReportsGetLogsReportPost } from '../fn/reports/api-nursery-manager-reports-get-logs-report-post';
import { ApiNurseryManagerReportsGetLogsReportPost$Params } from '../fn/reports/api-nursery-manager-reports-get-logs-report-post';
import { apiNurseryManagerReportsGetLogsReportPost$Plain } from '../fn/reports/api-nursery-manager-reports-get-logs-report-post-plain';
import { ApiNurseryManagerReportsGetLogsReportPost$Plain$Params } from '../fn/reports/api-nursery-manager-reports-get-logs-report-post-plain';
import { apiNurseryManagerReportsGetOrdersReportPost } from '../fn/reports/api-nursery-manager-reports-get-orders-report-post';
import { ApiNurseryManagerReportsGetOrdersReportPost$Params } from '../fn/reports/api-nursery-manager-reports-get-orders-report-post';
import { apiNurseryManagerReportsGetOrdersReportPost$Plain } from '../fn/reports/api-nursery-manager-reports-get-orders-report-post-plain';
import { ApiNurseryManagerReportsGetOrdersReportPost$Plain$Params } from '../fn/reports/api-nursery-manager-reports-get-orders-report-post-plain';
import { apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost } from '../fn/reports/api-nursery-manager-reports-get-orders-stakeholder-details-report-post';
import { ApiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Params } from '../fn/reports/api-nursery-manager-reports-get-orders-stakeholder-details-report-post';
import { apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain } from '../fn/reports/api-nursery-manager-reports-get-orders-stakeholder-details-report-post-plain';
import { ApiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain$Params } from '../fn/reports/api-nursery-manager-reports-get-orders-stakeholder-details-report-post-plain';
import { apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost } from '../fn/reports/api-nursery-manager-reports-get-order-stakeholder-items-report-details-post';
import { ApiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Params } from '../fn/reports/api-nursery-manager-reports-get-order-stakeholder-items-report-details-post';
import { apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Plain } from '../fn/reports/api-nursery-manager-reports-get-order-stakeholder-items-report-details-post-plain';
import { ApiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Plain$Params } from '../fn/reports/api-nursery-manager-reports-get-order-stakeholder-items-report-details-post-plain';
import { apiNurseryManagerReportsGetProductionDetailsReportPost } from '../fn/reports/api-nursery-manager-reports-get-production-details-report-post';
import { ApiNurseryManagerReportsGetProductionDetailsReportPost$Params } from '../fn/reports/api-nursery-manager-reports-get-production-details-report-post';
import { apiNurseryManagerReportsGetProductionDetailsReportPost$Plain } from '../fn/reports/api-nursery-manager-reports-get-production-details-report-post-plain';
import { ApiNurseryManagerReportsGetProductionDetailsReportPost$Plain$Params } from '../fn/reports/api-nursery-manager-reports-get-production-details-report-post-plain';
import { apiNurseryManagerReportsGetProductionReportPost } from '../fn/reports/api-nursery-manager-reports-get-production-report-post';
import { ApiNurseryManagerReportsGetProductionReportPost$Params } from '../fn/reports/api-nursery-manager-reports-get-production-report-post';
import { apiNurseryManagerReportsGetProductionReportPost$Plain } from '../fn/reports/api-nursery-manager-reports-get-production-report-post-plain';
import { ApiNurseryManagerReportsGetProductionReportPost$Plain$Params } from '../fn/reports/api-nursery-manager-reports-get-production-report-post-plain';
import { apiNurseryManagerReportsGetStoreReportPost } from '../fn/reports/api-nursery-manager-reports-get-store-report-post';
import { ApiNurseryManagerReportsGetStoreReportPost$Params } from '../fn/reports/api-nursery-manager-reports-get-store-report-post';
import { apiNurseryManagerReportsGetStoreReportPost$Plain } from '../fn/reports/api-nursery-manager-reports-get-store-report-post-plain';
import { ApiNurseryManagerReportsGetStoreReportPost$Plain$Params } from '../fn/reports/api-nursery-manager-reports-get-store-report-post-plain';
import { GetInventoryLogsReportQueryResult } from '../models/get-inventory-logs-report-query-result';
import { GetInventoryOutSummaryDetailsQueryResult } from '../models/get-inventory-out-summary-details-query-result';
import { GetInventoryOutSummaryQueryResult } from '../models/get-inventory-out-summary-query-result';
import { GetInvOutReportDetailsQueryResult } from '../models/get-inv-out-report-details-query-result';
import { GetInvOutReportQueryResult } from '../models/get-inv-out-report-query-result';
import { GetOrderReportDetailsQueryResult } from '../models/get-order-report-details-query-result';
import { GetOrderReportQueryResult } from '../models/get-order-report-query-result';
import { GetOrderStakeholderItemsReportDetailsQueryResult } from '../models/get-order-stakeholder-items-report-details-query-result';
import { GetProductionReportDetailsQueryResult } from '../models/get-production-report-details-query-result';
import { GetProductionReportQueryResult } from '../models/get-production-report-query-result';
import { GetStoreReportQueryResult } from '../models/get-store-report-query-result';

@Injectable({ providedIn: 'root' })
export class ReportsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiNurseryManagerReportsGetProductionReportPost()` */
  static readonly ApiNurseryManagerReportsGetProductionReportPostPath = '/api/NurseryManager/Reports/GetProductionReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetProductionReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetProductionReportPost$Plain$Response(params?: ApiNurseryManagerReportsGetProductionReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProductionReportQueryResult>> {
    return apiNurseryManagerReportsGetProductionReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetProductionReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetProductionReportPost$Plain(params?: ApiNurseryManagerReportsGetProductionReportPost$Plain$Params, context?: HttpContext): Observable<GetProductionReportQueryResult> {
    return this.apiNurseryManagerReportsGetProductionReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProductionReportQueryResult>): GetProductionReportQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetProductionReportPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetProductionReportPost$Response(params?: ApiNurseryManagerReportsGetProductionReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProductionReportQueryResult>> {
    return apiNurseryManagerReportsGetProductionReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetProductionReportPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetProductionReportPost(params?: ApiNurseryManagerReportsGetProductionReportPost$Params, context?: HttpContext): Observable<GetProductionReportQueryResult> {
    return this.apiNurseryManagerReportsGetProductionReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProductionReportQueryResult>): GetProductionReportQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerReportsGetProductionDetailsReportPost()` */
  static readonly ApiNurseryManagerReportsGetProductionDetailsReportPostPath = '/api/NurseryManager/Reports/GetProductionDetailsReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetProductionDetailsReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetProductionDetailsReportPost$Plain$Response(params?: ApiNurseryManagerReportsGetProductionDetailsReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProductionReportDetailsQueryResult>> {
    return apiNurseryManagerReportsGetProductionDetailsReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetProductionDetailsReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetProductionDetailsReportPost$Plain(params?: ApiNurseryManagerReportsGetProductionDetailsReportPost$Plain$Params, context?: HttpContext): Observable<GetProductionReportDetailsQueryResult> {
    return this.apiNurseryManagerReportsGetProductionDetailsReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProductionReportDetailsQueryResult>): GetProductionReportDetailsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetProductionDetailsReportPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetProductionDetailsReportPost$Response(params?: ApiNurseryManagerReportsGetProductionDetailsReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProductionReportDetailsQueryResult>> {
    return apiNurseryManagerReportsGetProductionDetailsReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetProductionDetailsReportPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetProductionDetailsReportPost(params?: ApiNurseryManagerReportsGetProductionDetailsReportPost$Params, context?: HttpContext): Observable<GetProductionReportDetailsQueryResult> {
    return this.apiNurseryManagerReportsGetProductionDetailsReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProductionReportDetailsQueryResult>): GetProductionReportDetailsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerReportsGetInvOutReportPost()` */
  static readonly ApiNurseryManagerReportsGetInvOutReportPostPath = '/api/NurseryManager/Reports/GetInvOutReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetInvOutReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutReportPost$Plain$Response(params?: ApiNurseryManagerReportsGetInvOutReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInvOutReportQueryResult>> {
    return apiNurseryManagerReportsGetInvOutReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetInvOutReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutReportPost$Plain(params?: ApiNurseryManagerReportsGetInvOutReportPost$Plain$Params, context?: HttpContext): Observable<GetInvOutReportQueryResult> {
    return this.apiNurseryManagerReportsGetInvOutReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInvOutReportQueryResult>): GetInvOutReportQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetInvOutReportPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutReportPost$Response(params?: ApiNurseryManagerReportsGetInvOutReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInvOutReportQueryResult>> {
    return apiNurseryManagerReportsGetInvOutReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetInvOutReportPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutReportPost(params?: ApiNurseryManagerReportsGetInvOutReportPost$Params, context?: HttpContext): Observable<GetInvOutReportQueryResult> {
    return this.apiNurseryManagerReportsGetInvOutReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInvOutReportQueryResult>): GetInvOutReportQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerReportsGetInvOutDetailsReportPost()` */
  static readonly ApiNurseryManagerReportsGetInvOutDetailsReportPostPath = '/api/NurseryManager/Reports/GetInvOutDetailsReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetInvOutDetailsReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutDetailsReportPost$Plain$Response(params?: ApiNurseryManagerReportsGetInvOutDetailsReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInvOutReportDetailsQueryResult>> {
    return apiNurseryManagerReportsGetInvOutDetailsReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetInvOutDetailsReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutDetailsReportPost$Plain(params?: ApiNurseryManagerReportsGetInvOutDetailsReportPost$Plain$Params, context?: HttpContext): Observable<GetInvOutReportDetailsQueryResult> {
    return this.apiNurseryManagerReportsGetInvOutDetailsReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInvOutReportDetailsQueryResult>): GetInvOutReportDetailsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetInvOutDetailsReportPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutDetailsReportPost$Response(params?: ApiNurseryManagerReportsGetInvOutDetailsReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInvOutReportDetailsQueryResult>> {
    return apiNurseryManagerReportsGetInvOutDetailsReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetInvOutDetailsReportPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutDetailsReportPost(params?: ApiNurseryManagerReportsGetInvOutDetailsReportPost$Params, context?: HttpContext): Observable<GetInvOutReportDetailsQueryResult> {
    return this.apiNurseryManagerReportsGetInvOutDetailsReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInvOutReportDetailsQueryResult>): GetInvOutReportDetailsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerReportsGetOrdersReportPost()` */
  static readonly ApiNurseryManagerReportsGetOrdersReportPostPath = '/api/NurseryManager/Reports/GetOrdersReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetOrdersReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetOrdersReportPost$Plain$Response(params?: ApiNurseryManagerReportsGetOrdersReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderReportQueryResult>> {
    return apiNurseryManagerReportsGetOrdersReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetOrdersReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetOrdersReportPost$Plain(params?: ApiNurseryManagerReportsGetOrdersReportPost$Plain$Params, context?: HttpContext): Observable<GetOrderReportQueryResult> {
    return this.apiNurseryManagerReportsGetOrdersReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrderReportQueryResult>): GetOrderReportQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetOrdersReportPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetOrdersReportPost$Response(params?: ApiNurseryManagerReportsGetOrdersReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderReportQueryResult>> {
    return apiNurseryManagerReportsGetOrdersReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetOrdersReportPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetOrdersReportPost(params?: ApiNurseryManagerReportsGetOrdersReportPost$Params, context?: HttpContext): Observable<GetOrderReportQueryResult> {
    return this.apiNurseryManagerReportsGetOrdersReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrderReportQueryResult>): GetOrderReportQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost()` */
  static readonly ApiNurseryManagerReportsGetOrdersStakeholderDetailsReportPostPath = '/api/NurseryManager/Reports/GetOrdersStakeholderDetailsReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain$Response(params?: ApiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderReportDetailsQueryResult>> {
    return apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain(params?: ApiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain$Params, context?: HttpContext): Observable<GetOrderReportDetailsQueryResult> {
    return this.apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrderReportDetailsQueryResult>): GetOrderReportDetailsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Response(params?: ApiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderReportDetailsQueryResult>> {
    return apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost(params?: ApiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Params, context?: HttpContext): Observable<GetOrderReportDetailsQueryResult> {
    return this.apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrderReportDetailsQueryResult>): GetOrderReportDetailsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost()` */
  static readonly ApiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPostPath = '/api/NurseryManager/Reports/GetOrderStakeholderItemsReportDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Plain$Response(params?: ApiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderStakeholderItemsReportDetailsQueryResult>> {
    return apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Plain(params?: ApiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Plain$Params, context?: HttpContext): Observable<GetOrderStakeholderItemsReportDetailsQueryResult> {
    return this.apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrderStakeholderItemsReportDetailsQueryResult>): GetOrderStakeholderItemsReportDetailsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Response(params?: ApiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderStakeholderItemsReportDetailsQueryResult>> {
    return apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost(params?: ApiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Params, context?: HttpContext): Observable<GetOrderStakeholderItemsReportDetailsQueryResult> {
    return this.apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrderStakeholderItemsReportDetailsQueryResult>): GetOrderStakeholderItemsReportDetailsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerReportsGetLogsReportPost()` */
  static readonly ApiNurseryManagerReportsGetLogsReportPostPath = '/api/NurseryManager/Reports/GetLogsReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetLogsReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetLogsReportPost$Plain$Response(params?: ApiNurseryManagerReportsGetLogsReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryLogsReportQueryResult>> {
    return apiNurseryManagerReportsGetLogsReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetLogsReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetLogsReportPost$Plain(params?: ApiNurseryManagerReportsGetLogsReportPost$Plain$Params, context?: HttpContext): Observable<GetInventoryLogsReportQueryResult> {
    return this.apiNurseryManagerReportsGetLogsReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoryLogsReportQueryResult>): GetInventoryLogsReportQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetLogsReportPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetLogsReportPost$Response(params?: ApiNurseryManagerReportsGetLogsReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryLogsReportQueryResult>> {
    return apiNurseryManagerReportsGetLogsReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetLogsReportPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetLogsReportPost(params?: ApiNurseryManagerReportsGetLogsReportPost$Params, context?: HttpContext): Observable<GetInventoryLogsReportQueryResult> {
    return this.apiNurseryManagerReportsGetLogsReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoryLogsReportQueryResult>): GetInventoryLogsReportQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerReportsGetStoreReportPost()` */
  static readonly ApiNurseryManagerReportsGetStoreReportPostPath = '/api/NurseryManager/Reports/GetStoreReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetStoreReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetStoreReportPost$Plain$Response(params?: ApiNurseryManagerReportsGetStoreReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStoreReportQueryResult>> {
    return apiNurseryManagerReportsGetStoreReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetStoreReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetStoreReportPost$Plain(params?: ApiNurseryManagerReportsGetStoreReportPost$Plain$Params, context?: HttpContext): Observable<GetStoreReportQueryResult> {
    return this.apiNurseryManagerReportsGetStoreReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStoreReportQueryResult>): GetStoreReportQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetStoreReportPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetStoreReportPost$Response(params?: ApiNurseryManagerReportsGetStoreReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStoreReportQueryResult>> {
    return apiNurseryManagerReportsGetStoreReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetStoreReportPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetStoreReportPost(params?: ApiNurseryManagerReportsGetStoreReportPost$Params, context?: HttpContext): Observable<GetStoreReportQueryResult> {
    return this.apiNurseryManagerReportsGetStoreReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStoreReportQueryResult>): GetStoreReportQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerReportsGetInvOutSummaryReportPost()` */
  static readonly ApiNurseryManagerReportsGetInvOutSummaryReportPostPath = '/api/NurseryManager/Reports/GetInvOutSummaryReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetInvOutSummaryReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutSummaryReportPost$Plain$Response(params?: ApiNurseryManagerReportsGetInvOutSummaryReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryOutSummaryQueryResult>> {
    return apiNurseryManagerReportsGetInvOutSummaryReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetInvOutSummaryReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutSummaryReportPost$Plain(params?: ApiNurseryManagerReportsGetInvOutSummaryReportPost$Plain$Params, context?: HttpContext): Observable<GetInventoryOutSummaryQueryResult> {
    return this.apiNurseryManagerReportsGetInvOutSummaryReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoryOutSummaryQueryResult>): GetInventoryOutSummaryQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetInvOutSummaryReportPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutSummaryReportPost$Response(params?: ApiNurseryManagerReportsGetInvOutSummaryReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryOutSummaryQueryResult>> {
    return apiNurseryManagerReportsGetInvOutSummaryReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetInvOutSummaryReportPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutSummaryReportPost(params?: ApiNurseryManagerReportsGetInvOutSummaryReportPost$Params, context?: HttpContext): Observable<GetInventoryOutSummaryQueryResult> {
    return this.apiNurseryManagerReportsGetInvOutSummaryReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoryOutSummaryQueryResult>): GetInventoryOutSummaryQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost()` */
  static readonly ApiNurseryManagerReportsGetInvOutSummaryDetailsReportPostPath = '/api/NurseryManager/Reports/GetInvOutSummaryDetailsReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain$Response(params?: ApiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryOutSummaryDetailsQueryResult>> {
    return apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain(params?: ApiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain$Params, context?: HttpContext): Observable<GetInventoryOutSummaryDetailsQueryResult> {
    return this.apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoryOutSummaryDetailsQueryResult>): GetInventoryOutSummaryDetailsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Response(params?: ApiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryOutSummaryDetailsQueryResult>> {
    return apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost(params?: ApiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Params, context?: HttpContext): Observable<GetInventoryOutSummaryDetailsQueryResult> {
    return this.apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoryOutSummaryDetailsQueryResult>): GetInventoryOutSummaryDetailsQueryResult => r.body)
    );
  }

}
